import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { rentalsService } from '../services/api';
import { AppNav } from '../components/AppNav';

interface LeaseRow {
  id: string;
  status: string;
  monthly_rent: number;
  start_date: string;
  end_date: string;
  tenant_name?: string;
  unit_name?: string;
  property_title?: string;
}

export default function LeasesPage() {
  const [items, setItems] = useState<LeaseRow[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    rentalsService
      .listLeases<LeaseRow>()
      .then((r) => setItems(r.items))
      .catch(() => setError('No se pudieron cargar los arrendamientos.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-[100dvh] bg-background">
      <AppNav />
      <main className="max-w-5xl mx-auto px-6 py-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-semibold tracking-tight">Arrendamientos</h1>
          <Link
            to="/admin/rentals/leases/new"
            className="text-sm bg-primary text-primary-foreground px-3 py-1.5 rounded-lg"
          >
            Nuevo arrendamiento
          </Link>
        </div>
        {error && <p className="text-sm text-destructive mb-4">{error}</p>}
        {loading ? (
          <p className="text-sm text-muted-foreground">Cargando…</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-muted-foreground">Sin arrendamientos aún.</p>
        ) : (
          <div className="space-y-2">
            {items.map((l) => (
              <Link
                key={l.id}
                to={`/admin/rentals/leases/${l.id}`}
                className="flex items-center justify-between border border-border rounded-xl px-4 py-3 bg-card text-sm hover:border-primary/40"
              >
                <span>
                  {l.tenant_name && <span className="font-medium">{l.tenant_name} · </span>}
                  {[l.property_title, l.unit_name].filter(Boolean).join(' · ')}
                  {(l.property_title || l.unit_name) && ' · '}
                  ${l.monthly_rent.toLocaleString('es-MX')} / mes · {l.start_date} → {l.end_date}
                </span>
                <span className={l.status === 'active' ? 'text-green-600' : 'text-muted-foreground'}>
                  {l.status === 'active' ? 'Activo' : l.status === 'ended' ? 'Terminado' : 'Cancelado'}
                </span>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
